import React from 'react';
import styled from 'styled-components';
import { typography, color } from 'styled-system';
const StyledSvg = styled('svg')(typography, color);

const Stopwatch = props => (
  <StyledSvg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 3.668c2.24 0 4.308.737 5.975 1.98l1.11-1.323a1.111 1.111 0 011.703 1.429L19.6 7.169a9.96 9.96 0 012.4 6.5c0 5.522-4.477 10-10 10s-10-4.478-10-10a9.96 9.96 0 012.4-6.5L3.212 5.754a1.111 1.111 0 111.703-1.429l1.11 1.324A9.956 9.956 0 0112 3.669zm0 2.223a7.778 7.778 0 100 15.555 7.778 7.778 0 000-15.555zm0 2.222c.614 0 1.111.497 1.111 1.11l.001 2.52A2.221 2.221 0 0112 15.892a2.222 2.222 0 01-1.112-4.147v-2.52c0-.614.498-1.111 1.112-1.111zM14.222.335a1.111 1.111 0 010 2.222H9.778a1.111 1.111 0 010-2.222h4.444z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </StyledSvg>
);
export default Stopwatch;
